import { onMounted, onBeforeUnmount } from 'vue'

const OVERLAY = '[data-overlay]'
const SCROLLABLE = '[data-scrollable]'
const PASSTHROUGH = '[data-passthrough]'

function nearestScrollable(target, overlay) {
  let el = target instanceof Element ? target : null
  while (el && el !== overlay) {
    if (el.matches(SCROLLABLE)) return el
    el = el.parentElement
  }
  return null
}

function atBoundary(pane, up, down) {
  const { scrollTop, scrollHeight, clientHeight } = pane
  const atTop = scrollTop <= 0
  const atBottom = scrollTop + clientHeight >= scrollHeight - 1
  return (up && atTop) || (down && atBottom)
}

function onWheel(e) {
  const overlay = e.target instanceof Element ? e.target.closest(OVERLAY) : null
  if (!overlay || e.target.closest(PASSTHROUGH)) return
  const pane = nearestScrollable(e.target, overlay)
  if (!pane) {
    if (e.cancelable) e.preventDefault()
    return
  }
  if (atBoundary(pane, e.deltaY < 0, e.deltaY > 0) && e.cancelable) e.preventDefault()
}

let lastTouchY = 0

function onTouchStart(e) {
  lastTouchY = e.touches[0]?.clientY ?? 0
}

function onTouchMove(e) {
  const overlay = e.target instanceof Element ? e.target.closest(OVERLAY) : null
  if (!overlay || e.target.closest(PASSTHROUGH)) return
  const y = e.touches[0]?.clientY ?? 0
  const dy = y - lastTouchY
  lastTouchY = y
  const pane = nearestScrollable(e.target, overlay)
  if (!pane) {
    if (e.cancelable) e.preventDefault()
    return
  }
  if (atBoundary(pane, dy > 0, dy < 0) && e.cancelable) e.preventDefault()
}

export function useOverlayScrollLock() {
  onMounted(() => {
    document.addEventListener('touchstart', onTouchStart, { passive: true })
    document.addEventListener('touchmove', onTouchMove, { passive: false })
    document.addEventListener('wheel', onWheel, { passive: false })
  })
  onBeforeUnmount(() => {
    document.removeEventListener('touchstart', onTouchStart)
    document.removeEventListener('touchmove', onTouchMove)
    document.removeEventListener('wheel', onWheel)
  })
}
